<script setup>
import { trans } from '@tools/translation';

const { pageSpaceUrl } = window;
</script>

<template>
  <div class="space-contact-success">
    <div class="space-contact-success__content">
      <div class="space-contact-success__icon-wrapper">
        <span class="space-contact-success__icon" />
      </div>

      <h4 class="space-contact-success__title">
        {{ trans('space.contact.success.title') }}
      </h4>

      <p class="space-contact-success__reinsurance">
        {{ trans('space.contact.success.reinsurance') }}
      </p>
    </div>

    <a
      class="btn btn--primary space-contact-success__return-link"
      :href="pageSpaceUrl"
    >
      {{ trans('space.contact.success.return_link') }}
    </a>
  </div>
</template>
